<ng-container *transloco="let t">
  <div class="wrapper-forms">
    <form [formGroup]="form">
      <div [formGroupName]="'testsForm'" class="testsForm">
        <h5>{{ t('Test data (first test and controls)') }}</h5>
        <table class="medication-table">
          <thead>
            <tr>
              <th></th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
              <th>{{ t('Date') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="remove-margin-bottom">
              <td class="text-small">{{ t("Modified Knot's Test") }}</td>
              <td>
                <mat-form-field>
                  <input appAutofocus
                    matInput
                    [matDatepicker]="picker1"
                    formControlName="modified-knots-1"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker1"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker2"
                    formControlName="modified-knots-2"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker2"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker3"
                    formControlName="modified-knots-3"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker3"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker4"
                    formControlName="modified-knots-4"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker4"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker5"
                    formControlName="modified-knots-5"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker5"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker5></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker6"
                    formControlName="modified-knots-6"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker6"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker6></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker7"
                    formControlName="modified-knots-7"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker7"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker7></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker8"
                    formControlName="modified-knots-8"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker8"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker8></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker9"
                    formControlName="modified-knots-9"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker9"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker9></mat-datepicker>
                </mat-form-field>
              </td>
            </tr>
            <tr class="remove-margin-bottom">
              <td class="text-small">{{ t('Ag Test') }}</td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker10"
                    formControlName="ag-test-1"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker10"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker10></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker11"
                    formControlName="ag-test-2"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker11"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker11></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker12"
                    formControlName="ag-test-3"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker12"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker12></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker13"
                    formControlName="ag-test-4"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker13"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker13></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker14"
                    formControlName="ag-test-5"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker14"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker14></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker15"
                    formControlName="ag-test-6"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker15"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker15></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker16"
                    formControlName="ag-test-7"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker16"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker16></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker17"
                    formControlName="ag-test-8"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker17"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker17></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker18"
                    formControlName="ag-test-9"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker18"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker18></mat-datepicker>
                </mat-form-field>
              </td>
            </tr>
            <tr class="remove-margin-bottom">
              <td class="text-small">
                {{ t('Manufacturer / Serial Number') }}
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker19"
                    formControlName="manufacturer-1"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker19"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker19></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker20"
                    formControlName="manufacturer-2"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker20"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker20></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker21"
                    formControlName="manufacturer-3"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker21"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker21></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker22"
                    formControlName="manufacturer-4"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker22"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker22></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker23"
                    formControlName="manufacturer-5"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker23"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker23></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker24"
                    formControlName="manufacturer-6"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker24"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker24></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker25"
                    formControlName="manufacturer-7"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker25"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker25></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker26"
                    formControlName="manufacturer-8"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker26"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker26></mat-datepicker>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker27"
                    formControlName="manufacturer-9"
                  
          [min]="minDate" [max]="today"
        />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker27"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker27></mat-datepicker>
                </mat-form-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div [formGroupName]="'clinicalProblems'" class="testsForm">
        <h5>
          {{ t('Major clinical problems and special findings in patients') }}
        </h5>
        <mat-form-field style="width: 100%" appearance="outline">
          <textarea matInput rows="4" [formControlName]="'note'"></textarea>
        </mat-form-field>
      </div>

      <div [formGroupName]="'diseaseStageForm'">
        <h5>{{ t('Disease stage, according to AHS') }}</h5>
        <div class="disease-stage">
          <mat-checkbox class="example-margin" formControlName="mild">{{
            t('I (asymptomatic, mild)')
          }}</mat-checkbox>
          <mat-checkbox class="example-margin" formControlName="moderate">{{
            t('II (moderate symptoms)')
          }}</mat-checkbox>
          <mat-checkbox class="example-margin" formControlName="serious">{{
            t('III (serious problems)')
          }}</mat-checkbox>
          <mat-checkbox class="example-margin" formControlName="cavae">{{
            t('IV (v. cavae syndrome)')
          }}</mat-checkbox>
        </div>
      </div>

      <div [formGroupName]="'dayForm'">
        <h5>
          {{
            t(
              'Doxycycline, 10 mg/kg, twice a day for a month (dose correction is possible):'
            )
          }}
        </h5>
        <table class="medication-table">
          <thead>
            <tr>
              <th>{{ t('Monday') }}</th>
              <th>{{ t('Tuesday') }}</th>
              <th>{{ t('Wednesday') }}</th>
              <th>{{ t('Thursday') }}</th>
              <th>{{ t('Friday') }}</th>
              <th>{{ t('Saturday') }}</th>
              <th>{{ t('Sunday') }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row; let i = $index) {
              <tr>
                @for (day of days; track day; let colIndex = $index) {
                  <td>
                    <div class="wrapper">
                      <input
                        matInput
                        [formControlName]="getControlName(day, i, 1)"
                        type="text"
                      />
                      <input
                        matInput
                        [formControlName]="getControlName(day, i, 2)"
                        type="text"
                      />
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div [formGroupName]="'ivermectin'" class="ivermectin-form">
        <h5>
          {{
            t(
              'Ivermectin, 6 - 12 meg/kg, every two weeks, for at least 6 months'
            )
          }}
        </h5>
        <table>
          <tr class="remove-margin-bottom">
            <td class="text-small">{{ t('Enter the application dates') }}</td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker28"
                  formControlName="application-date-1"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker28"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker28></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker29"
                  formControlName="application-date-2"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker29"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker29></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker30"
                  formControlName="application-date-3"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker30"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker30></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker31"
                  formControlName="application-date-4"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker31"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker31></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker32"
                  formControlName="application-date-5"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker32"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker32></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker33"
                  formControlName="application-date-6"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker33"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker33></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker34"
                  formControlName="application-date-7"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker34"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker34></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker35"
                  formControlName="application-date-8"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker35"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker35></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker36"
                  formControlName="application-date-9"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker36"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker36></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker37"
                  formControlName="application-date-10"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker37"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker37></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker38"
                  formControlName="application-date-11"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker38"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker38></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="picker39"
                  formControlName="application-date-12"
                
          [min]="minDate" [max]="today"
        />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker39"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker39></mat-datepicker>
              </mat-form-field>
            </td>
          </tr>
        </table>
      </div>

      <mat-form-field appearance="outline" class="full">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </form>
  </div>
</ng-container>
